<h1>{{ data.id }}  <ng-container *ngIf="data.firstName"> - {{ data.firstName }} {{ data.lastName }}  ({{ data.username }}) </ng-container> </h1>

<mat-dialog-content>
  <h3>Региони:</h3>
  <ul>
    <li *ngFor="let region of data.regions">{{ region }}</li>
  </ul>

  <h3>Вкупно:{{data.regions.length}}</h3>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="primary">Затвори</button>
</mat-dialog-actions>